var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"text-center mt-3"},[_vm._v("Loading "),_vm._l((_vm.dots),function(dot,index){return _c('span',{key:index,staticClass:"loader__dot",style:({ animationDelay: `${index * 0.2}s` })},[_vm._v(".")])})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center spinner-container"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }